import * as CryptoJS from "crypto-js";
import { __Moneda, __ClaveEnc } from "./environment";

function procedimientos() {}

procedimientos.prototype.FormatearPrecio = (Precio) => {
  let precioF = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: `${__Moneda}`,
  }).format(Precio);
  return precioF;
};

procedimientos.prototype.Agrupar = (datos, cantidadPorPag) => {
  let datosAgrupados = [];
  let datosTemp = [];
  let contador = 0;
  const cantidad = datos.length - 1;

  datos.forEach((dato, index) => {
    contador++;
    datosTemp.push(dato);

    if (contador === cantidadPorPag || index === cantidad) {
      datosAgrupados.push(datosTemp);

      datosTemp = [];
      contador = 0;
    }
  });

  return datosAgrupados;
};

procedimientos.prototype.GuardarYEncriptar = (llave, Datos) => {
  const datosEncrypt = CryptoJS.AES.encrypt(
    JSON.stringify(Datos),
    __ClaveEnc
  ).toString();
  localStorage.setItem(llave, datosEncrypt);
};

procedimientos.prototype.ObtenerYDesencriptar = (llave) => {
  const datosStorageEnc = localStorage.getItem(llave);
  const datosStorasEncStr = CryptoJS.AES.decrypt(
    datosStorageEnc,
    __ClaveEnc
  ).toString(CryptoJS.enc.Utf8);

  return JSON.parse(datosStorasEncStr);
};

procedimientos.prototype.CalcularProductos = (
  productos,
  productosCotizacion = []
) => {
  const { FormatearPrecio } = procedimientos.prototype;

  const productosCant = productos.map((producto) => {
    const productoPedido = productosCotizacion.find(
      (productoPedido) => producto.Codigo === productoPedido.Codigo
    );
    return {
      ...producto,
      Cantidad: productoPedido?.Cantidad
        ? parseInt(productoPedido.Cantidad)
        : 0,
      Precio_Formateado: FormatearPrecio(producto.Precio),
      Total: productoPedido?.Cantidad
        ? FormatearPrecio(
            parseInt(productoPedido.Cantidad) * parseFloat(producto.Precio)
          )
        : FormatearPrecio(0),
    };
  });

  return productosCant;
};

procedimientos.prototype.CalcularProducto = (productos, posicion, cantidad) => {
  const { FormatearPrecio } = procedimientos.prototype;

  productos[posicion] = {
    ...productos[posicion],
    Cantidad: parseInt(cantidad),
    Total: FormatearPrecio(
      parseInt(cantidad) * parseFloat(productos[posicion].Precio)
    ),
  };

  return productos;
};

procedimientos.prototype.CalcularTotal = (productos) => {
  const { FormatearPrecio } = procedimientos.prototype;
  const productosTotal = productos.map((producto) => {
    return {
      ...producto,
      Precio_Formateado: FormatearPrecio(producto.Precio),
      Total: FormatearPrecio(producto.Precio * producto.Cantidad),
    };
  });

  return productosTotal;
};

export default procedimientos;
